/* eslint-disable operator-assignment*/
import { AxiosResponse, AxiosError } from 'axios';
//
import {
  GET_FIELD_OPTIONS,
  GET_FIELD_OPTIONS_FAIL,
  GET_FIELD_OPTIONS_SUCCESS,
  IFieldOption,
  IStatusFieldOption,
  DELETE_PRODUCT_FIELD,
  DELETE_PRODUCT_FIELD_SUCCESS,
  DELETE_PRODUCT_FIELD_FAIL,
  IDeleteProductProps,
} from 'store/field-options/types';
import apiService from 'services/api';
import apiRoutes from 'services/api/routes';
import { getAccessToken } from 'lib/auth';
import { setLoading } from 'store/loading/actions';
import { ELoadingType } from 'store/loading/types';
import { getAxiosErrorMessage, handleError } from 'lib/helpers/error-handler';
import { statusColorsExcludingOther, statusColorOther } from 'store/field-options/status-colors';
import { IStoreState } from 'store';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

export const mapColorsToStatuses = (statuses: IFieldOption[]): IStatusFieldOption[] => {
  const returnArray: IStatusFieldOption[] = [];
  let colorIndex = 0;

  if (!statuses.length) {
    return returnArray;
  }

  statuses.forEach(fieldOption => {
    if (fieldOption.name !== 'other') {
      returnArray.push({
        ...fieldOption,
        color: statusColorsExcludingOther[colorIndex],
      });
    }
    colorIndex = colorIndex + 1;
    if (colorIndex > statusColorsExcludingOther.length) {
      colorIndex = 0;
    }
  });

  // add other option to tail of array
  returnArray.push({
    name: 'other',
    displayName: 'Other',
    color: statusColorOther,
  });

  return returnArray;
};

export const getFieldOptions = () => (dispatch: ThunkDispatch<void, void, AnyAction>) =>
  new Promise<void>((resolve, reject) => {
    dispatch({
      type: GET_FIELD_OPTIONS,
    });

    apiService
      .get(apiRoutes.fieldOptions, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      })
      .then(({ data }: AxiosResponse) => {
        const { products, productLines, regions, statuses, nonstandardRisks, transportModes, incoTerms } = data;
        dispatch({
          type: GET_FIELD_OPTIONS_SUCCESS,
          products,
          productLines,
          regions,
          statuses: mapColorsToStatuses(statuses),
          nonstandardRisks,
          transportModes,
          incoTerms,
        });
        resolve();
      })
      .catch((error: AxiosError) => {
        const errorMessage = getAxiosErrorMessage(error);
        if (!error.message.includes('401')) {
          dispatch({
            type: GET_FIELD_OPTIONS_FAIL,
            error: errorMessage,
          });
        }
        reject(errorMessage);
      });
  });

export const updateFieldOptions = () => (dispatch: ThunkDispatch<void, void, AnyAction>, getState: () => IStoreState) =>
  new Promise<void>((resolve, reject) => {
    dispatch({
      type: GET_FIELD_OPTIONS,
    });
    const { dealEdit } = getState();
    const { productLine, products: selectedProduct } = dealEdit;
    const postBody = {
      products: [
        {
          displayName: selectedProduct?.[0]?.name,
          productLine,
        },
      ],
    };

    apiService
      .post(apiRoutes.fieldOptions, postBody, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      })
      .then(({ data }: AxiosResponse) => {
        const { products, productLines, regions, statuses } = data;
        dispatch({
          type: GET_FIELD_OPTIONS_SUCCESS,
          products,
          productLines,
          regions,
          statuses: mapColorsToStatuses(statuses),
        });
        resolve();
      })
      .catch((error: AxiosError) => {
        const errorMessage = getAxiosErrorMessage(error);
        dispatch({
          type: GET_FIELD_OPTIONS_FAIL,
          error: errorMessage,
        });
        reject(errorMessage);
      })
      .finally(() => dispatch(setLoading(ELoadingType.NONE)));
  });

export function deleteProductPromise(name: string): Promise<{ data: IDeleteProductProps }> {
  const postBody = {
    products: [{ name }],
  };
  return apiService.delete(`${apiRoutes.fieldOptions}`, {
    data: postBody,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
}

export function deleteProduct(id: string) {
  return (dispatch: ThunkDispatch<void, void, AnyAction>) => {
    dispatch({ type: DELETE_PRODUCT_FIELD });
    deleteProductPromise(id)
      .then(({ data }: { data: IDeleteProductProps }) => {
        const { products, productLines, regions, statuses } = data;
        dispatch({
          type: DELETE_PRODUCT_FIELD_SUCCESS,
          products,
          productLines,
          regions,
          statuses: mapColorsToStatuses(statuses),
        });
      })
      .catch((error: AxiosError) => {
        const errorMessage = getAxiosErrorMessage(error);
        handleError(errorMessage);
        dispatch({
          type: DELETE_PRODUCT_FIELD_FAIL,
          error,
        });
      });
  };
}
